import React, { ReactNode } from 'react'

const Label = ({
  children,
  color = 'green',
}: {
  children: ReactNode
  color?: string
}) => {
  return (
    <div
      className={`flex px-6 py-1 h-8 w-max border border-bidfta-${color}
            text-12 md:text-10 text-bidfta-${color} bg-white font-semibold
            items-center`}
    >
      {children}
    </div>
  )
}

export default Label
